var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ApiUploadSpaceIcon } from '@/infrastructure/api-functions/api-upload-space-icon';
import { create } from '@patsnap/tahiti-core/utils/deferred';
import { dialog } from '@/infrastructure/decorators/dialog';
import { I18nService } from '@/services/i18n-service';
export const RequestCroppedImageService = Symbol('RequestCroppedImageService');
let CropImageServiceImp = class CropImageServiceImp {
    async _onReceived(croppedImage, next) {
        const { space_s3_key } = await this._apiUploadSpaceIcon.uploadSpaceIcon({
            poster: croppedImage,
        });
        this._deferred.resolve({
            base64: croppedImage,
            objectKey: space_s3_key,
        });
        next();
    }
    async cropImage(image) {
        this._deferred = create();
        console.log(this);
        this._requestCroppedImageService.onReceived(this._onReceived.bind(this));
        this._requestCroppedImageService.onAborted(() => { });
        this._requestCroppedImageService.request({
            title: this._i18nService.t('workspace.tips.corpHint'),
            base64Image: image,
        });
        return this._deferred.promise;
    }
};
__decorate([
    dialog(() => import('./components/CropSpaceIconDialog.vue')),
    __metadata("design:type", typeof (_a = typeof RequestCroppedImageService !== "undefined" && RequestCroppedImageService) === "function" ? _a : Object)
], CropImageServiceImp.prototype, "_requestCroppedImageService", void 0);
__decorate([
    inject(I18nService),
    __metadata("design:type", typeof (_b = typeof I18nService !== "undefined" && I18nService) === "function" ? _b : Object)
], CropImageServiceImp.prototype, "_i18nService", void 0);
__decorate([
    inject(ApiUploadSpaceIcon),
    __metadata("design:type", typeof (_c = typeof ApiUploadSpaceIcon !== "undefined" && ApiUploadSpaceIcon) === "function" ? _c : Object)
], CropImageServiceImp.prototype, "_apiUploadSpaceIcon", void 0);
CropImageServiceImp = __decorate([
    injectable()
], CropImageServiceImp);
export { CropImageServiceImp };
